import React, { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Modal from "../../components/Modal";
import { LINKS } from "../../utils/constants/links";
import $ from "jquery";
export const REACT_APP_VIDEO_ASSETS_URL = process.env.REACT_APP_VIDEO_ASSETS_URL;

export default function LandingPage() {
  const [videoModal, setVideoModal] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const stickyHeader = () => {
    const header = document.getElementById("header");
    const sticky = header.offsetTop;
    if (window.pageYOffset > sticky) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  };

  const addBodyClass = () => {
    const body = document.getElementById("body");
    if (
      ["/user-guidelines", "/privacy-policy", "/terms-service"].includes(
        pathname
      )
    ) {
      body.classList.add("contentPages");
    } else {
      if (body.classList.contains("contentPages")) {
        body.classList.remove("contentPages");
      }
    }
  };

  // useEffect(() => {
  //   addBodyClass();
  // }, [pathname]);

  useEffect(() => {
    $("body").addClass("island");

    return () => {
      $("body").removeClass("island");
    };
  }, []);

  useEffect(() => {
    window?.scrollTo(0, 0);

    const changeWidth = () => {
      setScreenWidth(window?.innerWidth);
    };
    window?.addEventListener("resize", changeWidth);
    window?.addEventListener("scroll", stickyHeader);
    return () => {
      window?.removeEventListener("resize", changeWidth);
      window?.removeEventListener("scroll", stickyHeader);
    };
  });
  const toggleNav = () => {
    setToggleMenu(!toggleMenu);
  };

  // const ref = useRef(null);
  // const locoOptions = {
  //   smooth: true,
  //   smartphone: {
  // 		smooth: true
  // 	},
  // 	tablet: {
  // 		smooth: true
  // 	}
  // }
  return (
    <>
      {/* <LocomotiveScrollProvider options={locoOptions} containerRef={ref} data-scroll-speed="4"> */}
      {/* <div data-scroll-container ref={ref}> */}

      <div>
        {/* <header className="">
        <div className="container clr">
          <a href="/">
            <img src="assets/imgs/virtua-logo.svg" alt="virtua" />
          </a>
          <div className="links float-right">
            <div className="social-links">
              <a
                href="https://discord.com/invite/virtua"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7662 18.9879C16.7662 18.9879 16.1457 18.2709 15.6302 17.645C16.8733 17.3627 17.973 16.6608 18.7336 15.6642C18.1164 16.0584 17.4567 16.3858 16.7662 16.6405C15.9698 16.972 15.1366 17.2126 14.2832 17.3576C12.8156 17.6171 11.3114 17.6135 9.84511 17.3467C8.98442 17.1858 8.14143 16.9457 7.32753 16.6297C6.89555 16.471 6.4766 16.2806 6.07432 16.0602C6.02745 16.0266 5.96942 16.0146 5.92255 15.981C5.88796 15.9701 5.87568 15.9474 5.85225 15.9354C5.54759 15.7651 5.37239 15.6512 5.37239 15.6512C6.10511 16.6269 7.16525 17.3232 8.36982 17.6201C7.85426 18.2579 7.22263 18.9977 7.22263 18.9977C6.20588 19.025 5.19781 18.8089 4.28712 18.3686C3.37643 17.9282 2.59103 17.2771 2 16.4724C2.05606 13.0957 2.90091 9.7755 4.47071 6.76273C5.84405 5.6971 7.52848 5.08019 9.28378 5L9.45899 5.20502C7.80937 5.60316 6.27014 6.34942 4.95056 7.39081C4.95056 7.39081 5.32552 7.18579 5.95492 6.91243C7.18587 6.36435 8.49927 6.01166 9.84511 5.86781C9.9418 5.85101 10.0394 5.83978 10.1375 5.83418C13.1035 5.44329 16.1204 5.98736 18.7448 7.38647C17.4936 6.39586 16.0408 5.67419 14.4819 5.26902L14.7162 5.00759C16.4682 5.09547 18.1493 5.70775 19.5293 6.76056C21.0991 9.77333 21.9439 13.0935 22 16.4702C21.4002 17.2681 20.6113 17.9135 19.7002 18.3518C18.789 18.7901 17.7826 19.0083 16.7662 18.9879ZM8.80728 11.2016C8.42528 11.1703 8.04249 11.2519 7.70898 11.4356C7.37548 11.6194 7.1068 11.8967 6.93812 12.2313C6.76943 12.5659 6.70859 12.9422 6.76357 13.311C6.81854 13.6798 6.98676 14.0239 7.24622 14.2982C7.50567 14.5725 7.84427 14.7643 8.21771 14.8484C8.59115 14.9326 8.98202 14.9052 9.33919 14.7698C9.69635 14.6345 10.0032 14.3975 10.2195 14.0899C10.4358 13.7822 10.5515 13.4183 10.5515 13.0456C10.5715 12.5763 10.399 12.1185 10.0719 11.7728C9.74489 11.427 9.29004 11.2216 8.80728 11.2016ZM15.0566 11.2016C14.6746 11.1703 14.2918 11.2519 13.9583 11.4356C13.6248 11.6194 13.3561 11.8967 13.1874 12.2313C13.0187 12.5659 12.9579 12.9422 13.0129 13.311C13.0678 13.6798 13.2361 14.0239 13.4955 14.2982C13.755 14.5725 14.0936 14.7643 14.467 14.8484C14.8405 14.9326 15.2313 14.9052 15.5885 14.7698C15.9457 14.6345 16.2525 14.3975 16.4688 14.0899C16.6851 13.7822 16.8008 13.4183 16.8008 13.0456C16.8208 12.5763 16.6483 12.1185 16.3212 11.7728C15.9942 11.427 15.5393 11.2216 15.0566 11.2016Z"
                    fill="#F4F4F4"
                  />
                </svg>
              </a>
              <a
                href="https://twitter.com/Virtuametaverse"
                target="_blank"
                rel="noreferrer"
              >
                
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.8098 6.22724C21.8677 6.14647 21.7821 6.04218 21.6894 6.07811C21.0307 6.33344 20.3423 6.50571 19.64 6.5906C20.4219 6.12348 21.0253 5.4124 21.3599 4.57053C21.394 4.48477 21.3003 4.40819 21.2195 4.4528C20.4928 4.85414 19.7091 5.14313 18.8949 5.30957C18.8608 5.31654 18.8257 5.30494 18.8018 5.27969C18.1908 4.63502 17.3866 4.20578 16.5098 4.05745C15.6147 3.90601 14.6946 4.05596 13.8938 4.48379C13.0931 4.91162 12.457 5.59313 12.0853 6.42144C11.7319 7.209 11.6365 8.08691 11.8108 8.93003C11.8243 8.99545 11.7731 9.05721 11.7065 9.05307C10.1224 8.95469 8.57469 8.53336 7.15868 7.81446C5.74627 7.09739 4.49554 6.09983 3.48267 4.8833C3.43772 4.82931 3.35252 4.83629 3.31977 4.89845C3.0046 5.49651 2.83958 6.16311 2.84003 6.8406C2.83875 7.51498 3.00425 8.17922 3.32178 8.77416C3.63932 9.36911 4.09905 9.87631 4.66003 10.2506C4.0651 10.2344 3.48178 10.0873 2.95128 9.82067C2.88291 9.78631 2.8009 9.83524 2.80446 9.91167C2.84583 10.8009 3.17228 11.6936 3.73734 12.3786C4.33866 13.1074 5.17328 13.6062 6.10003 13.7906C5.74328 13.8992 5.3729 13.9564 5.00003 13.9606C4.79709 13.9582 4.59454 13.9433 4.39356 13.9158C4.31904 13.9056 4.2582 13.9764 4.28428 14.0469C4.5607 14.7944 5.04903 15.4467 5.6911 15.9228C6.37755 16.4318 7.2056 16.7142 8.06003 16.7306C6.61723 17.8659 4.83591 18.4855 3.00003 18.4906C2.81138 18.4912 2.62282 18.4851 2.43471 18.4723C2.3287 18.4651 2.27995 18.6063 2.37132 18.6605C4.16009 19.7221 6.20462 20.2831 8.29003 20.2806C9.82972 20.2966 11.3572 20.0056 12.7831 19.4247C14.2091 18.8437 15.5051 17.9845 16.5952 16.8971C17.6854 15.8097 18.548 14.516 19.1326 13.0915C19.7172 11.667 20.0121 10.1403 20 8.6006V8.12077C20 8.0892 20.015 8.05951 20.0402 8.04048C20.7184 7.52834 21.3149 6.91691 21.8098 6.22724Z"
                    fill="#F4F4F4"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </header> */}

        <header id="header" className="fixed">
          <div className="header-container">
            <nav className="navigation">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <a href="https://virtua.com/" className="mainSiteLogo">
                  <img src="assets/imgs/home_white_icon.svg" alt="" />
                </a>
                <a href="/" className="logo-home">
                  <img
                    src="assets/imgs/virtua-logo.svg"
                    className="header-logo"
                    alt=""
                  />
                </a>
              </div>
              <div
                className={
                  toggleMenu
                    ? "hamburger relative"
                    : "hamburger relative change"
                }
                onClick={toggleNav}
              >
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
              </div>

              <div className="navigation-menu">
                <ul className="social-icons list-none">
                  <li className="blog-text">
                    <Link to="/monsterzone">Monster Zone</Link>
                  </li>
                  <li className="blog-text">
                    <a href="https://blog.virtua.com/" target="blank">
                      BLOG
                    </a>
                  </li>
                  <li>
                    <a href="https://discord.com/invite/virtua" target="blank">
                      <img src="assets/imgs/social/discord.svg" alt="discord" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/Virtuametaverse"
                      target="blank"
                    >
                      <img src="assets/imgs/social/twitter.svg" alt="twitter" />
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </header>

        {toggleMenu ? (
          ""
        ) : (
          // {!toggleMenu ? "mobile-navigation" : ""}
          <div className={!toggleMenu ? "mobile-navigation" : ""}>
            <div className="link-navigation">
              {/* <ul>
             <li>
               <a href="https://cardano.virtua.com/" target="_blank">Cardano Island</a>
             </li>
             <li>
               <a href="https://island.virtua.com/" >Virtua Island</a>
             </li>
           </ul> */}
              <ul className="social-icons" style={{ marginBottom: "15px" }}>
                <li className="blog-text">
                  <Link to="/monsterzone">Monster Zone</Link>
                </li>
                <li className="blog-text">
                  <a href="https://blog.virtua.com/" target="blank">
                    BLOG
                  </a>
                </li>
              </ul>
              <ul className="social-icons">
                <li>
                  <a href="https://discord.com/invite/virtua" target="blank">
                    <img src="assets/imgs/social/discord.svg" alt="discord" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/Virtuametaverse" target="blank">
                    <img src="assets/imgs/social/twitter.svg" alt="" />
                  </a>
                </li>
              </ul>
            </div>
            {/* <div className="social-navigation">
           <ul className="social-icons">
               <li className="blog-text"><a href="https://blog.virtua.com/" target="blank">BLOG</a></li>
               <li><a href="https://discord.com/invite/virtua" target="blank"><img src="assets/imgs/social/discord.svg" alt="discord" /></a></li>
               <li><a href="https://twitter.com/Virtuametaverse" target="blank"><img src="assets/imgs/social/twitter.svg" alt="" /></a></li>
           </ul>
       </div> */}
          </div>
        )}

        <div className="hero-section">
          <video
            poster="assets/imgs/intro-section-bg.jpg"
            className="bg"
            // src="virtuaHub-video.webm"
            autoPlay
            loop
            playsInline
            muted
          >
            {/* <source src="https://landsale-assets.bimtvi.com/virtuaHub-video.webm" type="video/webm"></source> */}
            <source
              src={`${REACT_APP_VIDEO_ASSETS_URL}virtua_island_bg.mp4`}
              type="video/mp4"
            ></source>
          </video>
          <div className="overlay"></div>
          <div className="txt">
            <div>
              <h1>
                {/* <img
                  className="logo"
                  src="assets/imgs/virtua-prime-logo-wht.svg"
                  alt="Virtua Prime"
                /> */}
                The Monster Zone
              </h1>
              <p>
                Buy Land or a Condo in the Virtua metaverse - and make it yours
              </p>
              <div className="cta-option text-center">
                <button
                  type="button"
                  className="btn btn-primary --custom-btn lg"
                  onClick={() => navigate(LINKS.ETHEREUM)}
                >
                  <span>Buy Land</span>
                </button>
              </div>
            </div>
          </div>
          <div className="watch-video-link">
            <button
              type="button"
              className="custom-btn-light btn"
              data-bs-toggle="modal"
              data-bs-target="#videoModal"
              onClick={() => setVideoModal(true)}
            >
              <span className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#9247FF" />
                  <path
                    d="M12.0868 8.83272C12.6377 8.41121 12.6377 7.58879 12.0868 7.16728C10.4218 5.89344 8.56256 4.88939 6.57872 4.19272L6.2163 4.06545C5.52294 3.82196 4.79056 4.28581 4.6967 4.99349C4.43443 6.97078 4.43443 9.02922 4.6967 11.0065C4.79056 11.7142 5.52294 12.178 6.2163 11.9345L6.57872 11.8073C8.56256 11.1106 10.4218 10.1066 12.0868 8.83272Z"
                    fill="white"
                  />
                </svg>
              </span>
              Watch Trailer
            </button>
          </div>
        </div>

        {/* <section className="intro globe-section">
        <img src="assets/imgs/globe-bg.jpg" alt="" className="bg" />
        <div className="overlay top"></div>
        <div className="overlay bottom"></div>
        <div className="txt text-center">
          <p className="m--auto mb--20 ">
            Virtua Prime is a hyper-realistic, immersive 3D world and the first
            planet in the Virtua Metaverse. Cardano Island was the first island
            launched on Virtua Prime.
          </p>

          <p className="m--auto mb--40 ">
            There’s a whole planet waiting to be discovered.
          </p>

          <div className="mb--40 btnsHolder">
            <button
              type="button"
              className="btn btn-primary custom-btn lg ml-10 mr--10"
              data-bs-toggle="modal"
              data-bs-target="#whitelistModal"
            >
              <span>Buy Land</span>
            </button>
            
          </div>
          <div data-scroll data-scroll-speed="1.5">
            <img
              src="assets/imgs/planetLabel.png"
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </section> */}

        <section className="intro vLand-section">
          <div className="overlay top"></div>
          <div className="overlay bottom"></div>
          <img src="assets/imgs/vLandSectionBg.jpg" alt="" className="bg" />

          <div className="txt align-left">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h2 className="section-title mb--30">
                    <span className="dBlock">What Virtua </span>Island Looks
                    like
                  </h2>
                  <p className="fw--600 f-wht fs-18 mb--30">
                    Welcome to the Virtua Island, the centre of the Virtua
                    Metaverse
                  </p>
                  <ul className="mb--60">
                    <li className="f-light-wht mb--20">
                      There is a{" "}
                      <span className="f-accent-shade fw--700">Virtua Hub</span>{" "}
                      - which connects all the islands and world’s together
                    </li>
                    <li className="f-light-wht mb--20">
                      All plots will be split in size;{" "}
                      <span className="f-accent-shade fw--700">
                        Small, Medium, Large & Giga
                      </span>
                    </li>
                    <li className="f-light-wht mb--20">
                      Several Experience Zones -{" "}
                      <span className="f-accent-shade fw--700">
                        Monster, Mech, Battlefield, Gamer
                      </span>{" "}
                      and more.
                    </li>
                  </ul>
                  <div className="info-boxes mb--30">
                    <div className="box border-span-hover gold-rarity">
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>

                      <h5 className="count">3</h5>
                      <p>City Zones</p>
                      <div className="info">10k Plots Each</div>
                    </div>
                    <div className="box border-span-hover blue-rarity">
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>

                      <h5 className="count">5</h5>
                      <p>Edge Zones</p>
                      <div className="info">5k Regular & 2 Giga Plots Each</div>
                    </div>
                    <div className="box border-span-hover accent-rarity">
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>
                      <span className="sp"></span>

                      <h5 className="count">8</h5>
                      <p>Condo Towers</p>
                      <div className="info">1k Condos Each</div>
                    </div>
                  </div>
                  <div className="mb--40 btnsHolder">
                    <button
                      type="button"
                      className="btn btn-primary --custom-btn lg ml-10 mr--10"
                      onClick={() => navigate(LINKS.ETHEREUM)}
                    >
                      <span>Buy Land</span>
                    </button>
                    {/* <a
                    href="https://discord.com/invite/virtua"
                    className="btn custom-btn-light lg ml-10 mr--10"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Find out more
                  </a> */}
                  </div>
                </div>
                <div className="col-lg-6">
                  <img
                    src="assets/imgs/vLandSectionMap.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="intro">
          <img src="assets/imgs/intro-section-bg.jpg" alt="" className="bg" />
          <img
            src="assets/imgs/intro-section-bg-mob.jpg"
            alt=""
            className="bg mob"
          />
          <div className="overlay top"></div>
          <div className="overlay"></div>
          <div className="txt text-center">
            <h2 className="section-title mb--30">
              {/* <span className="dBlock sub">Virtua Prime</span> */}
              {/* <span className="dBlock sub">Virtua Island</span> */}
              The Monster Zone
            </h2>
            <p className="mb--20">
              The first area for sale on Virtua Island will be the fearsome
              Monster Zone. With land plots situated just outside the
              bone-chilling Monster Park… Unpredictable surprises lurk in the
              gloom and darkness, and travellers tell stories of vast mythical
              beasts, hidden rewards, and riches buried under the soil and
              swamps.
            </p>

            <p className="mb--40">
              Owning a Land Plot or Condo in the Edge Zone that borders the
              Monster Zone is one of the most prestigious status indicators that
              an inhabitant of Virtua Prime can possibly achieve.
            </p>
            <div className="btnsHolder">
              <button
                type="button"
                className="btn btn-primary --custom-btn lg ml-10 mr--10"
                onClick={() => navigate(LINKS.ETHEREUM)}
              >
                <span>Buy Land</span>
              </button>
              {/* <a
              href="https://discord.com/invite/virtua"
              className="btn custom-btn-light lg ml-10 mr--10"
              target="_blank"
              rel="noreferrer"
            >
              Find out more
            </a> */}
            </div>
          </div>
        </section>

        <section className="intro monsterZone-land-section">
          <img
            src="assets/imgs/monsterZone-land-bg.jpg"
            alt=""
            className="bg"
          />

          <div className="overlay top"></div>
          <div className="overlay bottom"></div>
          <div className="txt text-left">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex flex-column align-items-start justify-content-center">
                  <h2 className="section-title mb--30">Monster Zone Land</h2>
                  <p className="mb--20">
                    There are a fixed number of plots on each island and zone.
                    There are different attributes that define each parcel of
                    Land which is indicated in the Land Deed.
                  </p>
                  <p className="mb--40">
                    Your Land Deed is a visual description of the land plot
                    itself and has the following information.
                  </p>
                  <ul className="mb--40">
                    <li className=" mb--20 f-accent-shade fw--700">
                      Serial Number / Deed index
                    </li>
                    <li className=" mb--20 f-accent-shade fw--700">Name</li>
                    <li className=" mb--20 f-accent-shade fw--700">
                      Rarity indicator (Not visible for the users)
                    </li>
                  </ul>
                  <p className="mb--40">
                    These values / stats combined, determine how rare the plot
                    is being directly relevant to the cost. The attributes will
                    be revealed only after the sale.
                  </p>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-md-6 col-lg-6 text-center">
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">Land Bots</h5>
                        <p>
                          If its holds a Land Bots, only after purchase we would
                          know what kind of Lands Bots it had
                        </p>
                      </div>
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">Game Cubes</h5>
                        <p>
                          Everything in Virtua Prime has a metagame element.
                          Discoverable items have a future gamification
                          capability.
                        </p>
                      </div>
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">Relics</h5>
                        <p>
                          Mysterious and powerful items which can change or
                          enhance land properties.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6 text-center">
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">NPC</h5>
                        <p>
                          NPCs comes with the plots and are defined in details
                          later
                        </p>
                      </div>
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">Resources</h5>
                        <p>Resources you can mine / harvest from the plots</p>
                      </div>
                      <div className="box border-span-hover accent-rarity">
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <span className="sp"></span>
                        <h5 className="title">Loot Boxes</h5>
                        <p>
                          Loot boxes will appear on your land over time that you
                          may collect and open for a surprise. Indicators here
                          will show the type of Loot boxes / creates the land
                          will yield overtime.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="zonesInfo">
          <div className="zonesPrice">
            <div className="txt">
              <h2 className="section-title mb--30">Monster Zone Prices</h2>
              <p className="m-auto mb--40">
                Almost all of our land plots are available to purchase on the
                Ethereum network, using{" "}
                <strong className="f-accent-shade">TVK</strong> as well as{" "}
                <strong className="f-accent-shade">ETH</strong>, with{" "}
                <strong className="f-accent-shade">10% discount</strong> if
                purchased using our native token{" "}
                <strong className="f-accent-shade">TVK</strong>.<br />
                This will be pegged to a dollar value as on the chart below.
              </p>
              <div className="btnsHolder">
                <button
                  type="button"
                  className="btn btn-primary --custom-btn lg ml-10 mr--10"
                  onClick={() => navigate(LINKS.ETHEREUM)}
                >
                  <span>Buy Land</span>
                </button>
                {/* <a
                href="https://discord.com/invite/virtua"
                className="btn custom-btn-light lg ml-10 mr--10"
                target="_blank"
                rel="noreferrer"
              >
                Find out more
              </a> */}
              </div>
            </div>
            <div className="monsterZonePriceTable">
              <div className="container">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" width="25%">
                          Size
                        </th>
                        <th scope="col" width="25%">
                          Area
                        </th>
                        <th scope="col" width="25%">
                          # of plots
                        </th>
                        <th scope="col" width="25%">
                          Usd / Plot
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Small</th>
                        <td>
                          10,000 m<sup>2</sup>
                        </td>
                        <td>2,690</td>
                        <td>$400</td>
                      </tr>
                      <tr>
                        <th scope="row">Medium</th>
                        <td>
                          40,000 m<sup>2</sup>
                        </td>
                        <td>1,950</td>
                        <td>$750</td>
                      </tr>
                      <tr>
                        <th scope="row">Large</th>
                        <td>
                          250,000 m<sup>2</sup>
                        </td>
                        <td>860</td>
                        <td>$1250</td>
                      </tr>
                      <tr>
                        <th scope="row">Gigaplot</th>
                        <td>
                          25, 000,000 m<sup>2</sup>
                        </td>
                        <td>2</td>
                        <td>$50,000</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2">Total</td>
                        <td>5,502</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" width="25%">
                          Size
                        </th>
                        <th scope="col" width="25%">
                          Area
                        </th>
                        <th scope="col" width="25%">
                          # OF Condos
                        </th>
                        <th scope="col" width="25%">
                          USD / CONDO
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Condo</th>
                        <td>
                          83.6 m<sup>2</sup>
                        </td>
                        <td>1,000</td>
                        <td>$100</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2">Total</td>
                        <td>1,000</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className="txt benefits pt--0 ">
                  <h2 className="section-title mb--20 f-accent-shade">
                    <span className="sub fw--700">Cardano Benefits</span>
                  </h2>
                  <p className="m-auto mb--0">
                    Virtua Island is open to anyone and everyone. If you’re a
                    Cardano community member wishing to own a plot on Virtua
                    Island - no problem. We have allocated 500 plots to the
                    Cardano community - Simply buy your land plot and mint it,
                    and pay in ADA. Easy.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="zoneRarity">
            <div className="txt pt--0">
              <h2 className="section-title mb--30">Monster Zone Land Rarity</h2>
              <h2 className="section-title mb--20 f-accent-shade">
                <span className="sub">Monster Zone - TVK/ETH</span>
              </h2>
            </div>
            <div className="container">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Rarity</th>
                      <th scope="col">RESOURCES</th>
                      <th scope="col">LAND BOT SLOTS</th>
                      <th scope="col">NPC SLOTS</th>
                      <th scope="col">SMALL PLOTS</th>
                      <th scope="col">MEDIUM PLOTS</th>
                      <th scope="col">LARGE PLOTS</th>
                      <th scope="col">GIGA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        COMMON
                      </th>
                      <td>Obsidian, Spirit Silk</td>
                      <td>0</td>
                      <td>S:0, M:1, L:2</td>
                      <td>960</td>
                      <td>720</td>
                      <td>320</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        UNCOMMON
                      </th>
                      <td>Obsidian, Wood, Radia</td>
                      <td>1</td>
                      <td>S:1, M:2, L:3</td>
                      <td>720</td>
                      <td>540</td>
                      <td>240 </td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        RARE
                      </th>
                      <td>Radia, Gold, Spirit Silk</td>
                      <td>2</td>
                      <td>S:2, M:3, L:4</td>
                      <td>480</td>
                      <td>360</td>
                      <td>160</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        SPECIAL
                      </th>
                      <td>Gold, Wood, Aquions</td>
                      <td>3</td>
                      <td>S:3, M:4, L:5</td>
                      <td>168</td>
                      <td>126</td>
                      <td>56</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        LEGENDARY
                      </th>
                      <td>aDNA, Radia, Aquions</td>
                      <td>5</td>
                      <td>S:5, M:5, L:5</td>
                      <td>72</td>
                      <td>54</td>
                      <td>24</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th scope="row" className="text-uppercase">
                        MYTHICAL
                      </th>
                      <td>aDNA, Radia, Aquions, Gold</td>
                      <td>14</td>
                      <td>G:5</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                      <td>2</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div>
                <div className="txt pt--0 pb--0">
                  <h2 className="section-title mb--30 f-accent-shade">
                    <span className="sub">Monster Zone - Cardano</span>
                  </h2>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Rarity</th>
                        <th scope="col">RESOURCES</th>
                        <th scope="col">LAND BOT SLOTS</th>
                        <th scope="col">NPC SLOTS</th>
                        <th scope="col">SMALL PLOTS</th>
                        <th scope="col">MEDIUM PLOTS</th>
                        <th scope="col">LARGE PLOTS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row" className="text-uppercase">
                          COMMON
                        </th>
                        <td>Obsidian, Spirit Silk</td>
                        <td>0</td>
                        <td>S:0, M:1, L:2</td>
                        <td>116</td>
                        <td>60</td>
                        <td>24</td>
                      </tr>
                      <tr>
                        <th scope="row" className="text-uppercase">
                          UNCOMMON
                        </th>
                        <td>Obsidian, Wood, Radia</td>
                        <td>1</td>
                        <td>S:1, M:2, L:3</td>
                        <td>87</td>
                        <td>45</td>
                        <td>18</td>
                      </tr>
                      <tr>
                        <th scope="row" className="text-uppercase">
                          RARE
                        </th>
                        <td>Radia, Gold, Spirit Silk</td>
                        <td>2</td>
                        <td>S:2, M:3, L:4</td>
                        <td>58</td>
                        <td>30</td>
                        <td>12</td>
                      </tr>
                      <tr>
                        <th scope="row" className="text-uppercase">
                          SPECIAL
                        </th>
                        <td>Gold, Wood, Aquions</td>
                        <td>3</td>
                        <td>S:3, M:4, L:5</td>
                        <td>20</td>
                        <td>11</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <th scope="row" className="text-uppercase">
                          LEGENDARY
                        </th>
                        <td>aDNA, Radia, Aquions</td>
                        <td>5</td>
                        <td>S:5, M:5, L:5</td>
                        <td>9</td>
                        <td>4</td>
                        <td>2</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="zoneOwnershipBenefits">
            <div className="txt">
              <h2 className="section-title mb--30">
                Monster Zone
                <br />
                Land Ownership Benefits
              </h2>
              <p className="m--auto">
                Land plot ownership brings benefits both with respect to the
                plots as well as with respect to the wider Monster Zone. The
                table below outlines the benefit matrix.{" "}
              </p>
            </div>
            <div className="container">
              <div className="table-responsive mb--100">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Small</th>
                      <th scope="col">Medium</th>
                      <th scope="col">Large</th>
                      <th scope="col">Giga</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row" className=" ">
                        Crib
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Resources
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Land Bot slots
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Relics
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        NPCs
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Loot boxes
                      </th>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Rev share from Monster Zone
                      </th>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    {/* <tr>
                    <th scope="row" className=" ">
                      Multiple buildings
                    </th>
                    <td>
                      <img src="assets/imgs/cross.svg" alt="" />
                    </td>
                    <td>
                      <img src="assets/imgs/cross.svg" alt="" />
                    </td>
                    <td>
                      <img src="assets/imgs/tick.svg" alt="" />
                    </td>
                    <td>
                      <img src="assets/imgs/tick.svg" alt="" />
                    </td>
                  </tr> */}
                    <tr>
                      <th scope="row" className=" ">
                        Free Land Bots
                      </th>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className=" ">
                        Owned Condo Tower
                      </th>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/cross.svg" alt="" />
                      </td>
                      <td>
                        <img src="assets/imgs/tick.svg" alt="" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-center tableInfo">
                  <p>
                    Note that rarity can impact the above (e.g. Common small
                    plots have no land bot slots)
                  </p>
                </div>
              </div>

              <div></div>
            </div>
          </div>
        </section>

        <section className="dest-section">
          <img
            src="assets/imgs/destination-section-bg.jpg"
            alt=""
            className="bg"
          />
          <img
            src="assets/imgs/destination-section-bg-mob.jpg"
            alt=""
            className="bg mob"
          />
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-5 character-section">
                <h2 className="section-title mb--30">
                  <span className="dBlock">Virtua Prime</span>as a Destination
                </h2>
                {/* <img
                src="assets/imgs/destination-character.png"
                alt=""
                className="avatar"
              /> */}
              </div>
              <div className="col-lg-7 txtHolder">
                <ul>
                  <li>
                    <h5>For Fans </h5>
                    <p>
                      Connect with the brands you love in new, exciting ways.
                      Each brand that partners with Virtua will have a different
                      type of experience in the metaverse.
                    </p>
                  </li>
                  <li>
                    <h5>For Creators</h5>
                    <p>
                      Give your fans new and immersive content experiences.
                      Expand your brand by utilizing one of the many land plots
                      on Virtua Prime.
                    </p>
                  </li>
                  <li>
                    <h5>For NFT Lovers</h5>
                    <p>
                      Expand your NFT collection of NFTs by acquiring one of the
                      many new NFTs that will arrive with Virtua Prime, and show
                      off your NFT collections in your own customised Fancave.
                    </p>
                  </li>
                  <li>
                    <h5>For Social</h5>
                    <p>
                      Keep up with friends, and meet like-minded people in one
                      of the many experiences on Virtua Prime.
                    </p>
                  </li>
                  <li>
                    <h5>For Gamers</h5>
                    <p>
                      Play some awesome web3 games that will include additional
                      utility and benefits for owners.
                    </p>
                  </li>
                  <li>
                    <h5 className="f-accent-shade">For Landowners</h5>
                    <p>
                      Cultivate your land plot...what will you create? Will you
                      build a humble family villa or reach for the stars and
                      construct a skyscraper that can be seen for miles around?
                      Profit from your land by extracting resources from it
                      using Land Bots, and have unique interactions with NPCs
                      that others cannot by stationing them on your plot.
                    </p>
                  </li>
                </ul>
                <div className="btnsHolder">
                  <button
                    type="button"
                    className="btn btn-primary --custom-btn lg"
                    onClick={() => navigate(LINKS.ETHEREUM)}
                  >
                    <span>Buy Land</span>
                  </button>
                  {/* <a
                  href="/"
                  className="btn custom-btn-light lg"
                  target="_blank"
                  rel="noreferrer"
                >
                  Find out more
                </a> */}
                  <a
                    href="https://discord.com/invite/virtua"
                    className="btn custom-btn-light lg"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="icon">
                      <img src="assets/imgs/social/discord.svg" alt="" />
                    </span>
                    Join Discord
                  </a>
                  <a
                    href="https://twitter.com/Virtuametaverse"
                    className="btn custom-btn-light lg"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="icon">
                      <img src="assets/imgs/social/twitter.svg" alt="" />
                    </span>
                    Join Twitter
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className={`modal ${videoModal ? "show" : "fade"}`}
          id="videoModal"
          tabIndex="-1"
          aria-labelledby="videoModalLabel"
          aria-hidden="true"
          style={{ display: videoModal ? "block" : "none" }}
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content dark">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setVideoModal(false)}
              ></button>
              <div className="modal-body p--0">
                {videoModal && (
                  <video
                    className="bg"
                    // src="virtuaHub-video.webm"
                    autoPlay
                    loop
                    playsInline
                    // muted
                  >
                    <source
                      src="https://landsale-assets.bimtvi.com/virtua-prime/virtua-prime-video.mp4"
                      type="video/mp4"
                    ></source>
                  </video>
                  // <div>

                  //   <iframe
                  //     // src="https://player.vimeo.com/video/696482313?background=1"
                  //     src="https://player.vimeo.com/video/696482313?background=1"
                  //     // <iframe title="vimeo-player" src="https://player.vimeo.com/video/759408598?h=843521ca44" width="640" height="360" frameborder="0" allowfullscreen></iframe>
                  //     frameBorder={0}
                  //     title="testing"
                  //     webkitallowfullscreen="true"
                  //     mozallowfullscreen="true"
                  //     allowFullScreen
                  //     controls="0"
                  //   />
                  // </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal />
        {/* <SuccessModal /> */}
        <Footer />
      </div>

      {/* </LocomotiveScrollProvider> */}
    </>
  );
}
